import type { Store } from '@recipes/contracts';

type Labelled = Pick<Store, 'name' | 'kind' | 'parentName' | 'street' | 'city'>;

/**
 * How a store is called wherever one is picked: a chain by its name, a branch by its name with
 * the chain in front when the name does not say it ("Netto Hauptstraße") – and with its street
 * and town, because three "Lidl" look the same otherwise (user, 2026-09-25: "lidl lidl lidl aber wo").
 */
export function storeLabel(store: Labelled, options: { address?: boolean } = {}): string {
  const base =
    store.kind === 'BRANCH' && store.parentName && !store.name.includes(store.parentName)
      ? `${store.parentName} ${store.name}`
      : store.name;
  if (options.address === false || store.kind !== 'BRANCH') return base;
  const address = [store.street, store.city].filter(Boolean).join(', ');
  return address ? `${base} · ${address}` : base;
}
